var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "164px",
    height: "53px",
    viewBox: "0 0 164 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 -1.13731941e-13 150 -1.13731941e-13 150 10.6730495 15.2818834 10.6730495 15.2818834 49 0 49"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-2",
    width: 5.28507864,
    height: 5.28507864,
    x: -5.28507864,
    y: -5.28507864,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image-3",
    transform: "scale(0.105701573,0.105701573)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image-3",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAZhJREFUaAXll1VuA0EQRNeHCJPDzHj/I4SZGZ0TJK+iWHLinvV3jVsqaTXzU0+v11AURfHVkCueR4jlNILo+ZpYwvwHqcOMumm5p3AEc8P5mBPMJGXLYKzMTABzR7IwUwZzC6TVmo2XmBGM7m1GZVU6WjOtnxWM1qgMRmtoM9nB6PskWjN9ZOuj22b0PZIVjH6DRWYeOJ+y0UJR/ZBsG5hpJzPDlNX/lmjNHjnPCmbGyUyVspckZSYbmCcgZ4nNVGl6QSIzdjBD7QLzDOgcsZlBmp6TaM2yg5m30UJRmTlLmHnh3ApmoAXMAvc2I5hTEr0zMrNoQ0LRfpKCec0NZsnNzAmFozWTGSuYPgqnYN64WyY2I5hjEpmxg+ltAbNio4WigjkikZl3zrOCWQXIZnpoekhSZrKB+QByzUYLRbvJAYnMZAez7mZmP2GmVqlUrGC6AEnCcLfhZEYweyR6Z2qcb2YDw5pZwXSWmPnkbsvJjGB2SbRmnjCsUxMMZ4Kxmg7a7pA/ML9wViAq2wTjClKH2ebhx4xAvgGD91PfHY5rAgAAAABJRU5ErkJggg=="
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "information",
    transform: "translate(-49.000000, -32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(49.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy-2"
  }, /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.28,
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#pattern-2)",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#000000",
    x: 14.5,
    y: 10.5,
    width: 149,
    height: 42
  }), /*#__PURE__*/React.createElement("text", {
    id: "WhiteSpace",
    fontFamily: "NotoSansCJKtc-Medium, Noto Sans CJK TC",
    fontSize: 18,
    fontWeight: 400,
    "line-spacing": 44,
    letterSpacing: 1.8800001,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 31,
    y: 29
  }, "WhiteSpace")))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlock);
export default __webpack_public_path__ + "static/media/logo_block.3eb68716.svg";
export { ForwardRef as ReactComponent };